var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 9,
    viewBox: "0 0 5 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.180138 0.115799C0.281997 0.0309661 0.413373 -0.00994646 0.545388 0.00205482C0.677402 0.0140561 0.799247 0.0779886 0.884138 0.179798L4.21714 4.1798C4.26104 4.22998 4.29446 4.28843 4.31543 4.35171C4.33641 4.415 4.34451 4.48184 4.33927 4.54831C4.33404 4.61477 4.31556 4.67952 4.28493 4.73873C4.25429 4.79795 4.21213 4.85045 4.16091 4.89313C4.10969 4.93581 4.05046 4.96782 3.98669 4.98727C3.92292 5.00672 3.8559 5.01322 3.78958 5.00638C3.72326 4.99955 3.65898 4.97953 3.60051 4.94748C3.54204 4.91544 3.49058 4.87203 3.44914 4.8198L0.116138 0.819799C0.0313053 0.71794 -0.00960686 0.586563 0.00239418 0.454549C0.0143952 0.322535 0.0783286 0.20069 0.180138 0.115799Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.180138 8.88394C0.0783284 8.79905 0.014395 8.6772 0.002394 8.54519C-0.00960703 8.41318 0.0313051 8.2818 0.116138 8.17994L3.44914 4.17994C3.49058 4.12771 3.54204 4.0843 3.60051 4.05226C3.65898 4.02021 3.72326 4.00019 3.78958 3.99336C3.8559 3.98652 3.92292 3.99302 3.98669 4.01247C4.05046 4.03192 4.10969 4.06393 4.16091 4.10661C4.21213 4.14929 4.25429 4.20179 4.28493 4.26101C4.31556 4.32022 4.33404 4.38497 4.33927 4.45143C4.34451 4.5179 4.33641 4.58474 4.31543 4.64803C4.29446 4.71131 4.26104 4.76976 4.21714 4.81994L0.884138 8.81994C0.799247 8.92175 0.677401 8.98568 0.545387 8.99768C0.413373 9.00969 0.281997 8.96877 0.180138 8.88394Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.2ce01ef6c31f98276a66152df8038ed6.svg";
export { ForwardRef as ReactComponent };